<template>
  <Teleport to="body">
    <div class="cliente-overlay" @click.self="$emit('cerrar')">
      <div class="cliente-modal">

        <div class="cm-header">
          <span class="fw-bold" style="font-size:16px">Nuevo Cliente</span>
          <button class="cm-close" @click="$emit('cerrar')">✕</button>
        </div>

        <div class="cm-body">
          <!-- Tipo persona -->
          <div class="mb-3">
            <label class="cm-label">TIPO DE PERSONA</label>
            <div class="d-flex gap-2">
              <button class="btn btn-sm flex-grow-1" :class="form.tipoper==='N' ? 'btn-purple' : 'btn-outline-secondary'" @click="form.tipoper='N'; form.tipodocid=1">
                Natural (DNI)
              </button>
              <button class="btn btn-sm flex-grow-1" :class="form.tipoper==='J' ? 'btn-purple' : 'btn-outline-secondary'" @click="form.tipoper='J'; form.tipodocid=3">
                Jurídica (RUC)
              </button>
            </div>
          </div>

          <!-- DNI / RUC -->
          <div class="mb-3">
            <label class="cm-label">{{ form.tipoper === 'J' ? 'RUC' : 'DNI' }}</label>
            <input v-model="form.nrodoc" type="text" class="form-control" :maxlength="form.tipoper==='J' ? 11 : 8"
              :placeholder="form.tipoper==='J' ? '20XXXXXXXXX' : '12345678'" @input="form.nrodoc = form.nrodoc.replace(/\D/g,'')"/>
          </div>

          <!-- Nombres -->
          <template v-if="form.tipoper === 'N'">
            <div class="row g-2 mb-3">
              <div class="col-6">
                <label class="cm-label">NOMBRES</label>
                <input v-model="form.nombre" type="text" class="form-control" placeholder="Ej: MARIA ELENA" style="text-transform:uppercase" />
              </div>
              <div class="col-6">
                <label class="cm-label">AP. PATERNO</label>
                <input v-model="form.ape_pat" type="text" class="form-control" placeholder="Ej: GARCIA" style="text-transform:uppercase" />
              </div>
              <div class="col-12">
                <label class="cm-label">AP. MATERNO</label>
                <input v-model="form.ape_mat" type="text" class="form-control" placeholder="Ej: LOPEZ" style="text-transform:uppercase" />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mb-3">
              <label class="cm-label">RAZÓN SOCIAL</label>
              <input v-model="form.nombre" type="text" class="form-control" placeholder="Ej: EMPRESA S.A.C" style="text-transform:uppercase" />
            </div>
          </template>

          <!-- Contacto -->
          <div class="row g-2 mb-3">
            <div class="col-6">
              <label class="cm-label">TELÉFONO</label>
              <input v-model="form.telefono" type="text" class="form-control" placeholder="9XXXXXXXX" />
            </div>
            <div class="col-6">
              <label class="cm-label">EMAIL</label>
              <input v-model="form.email" type="email" class="form-control" placeholder="correo@ejemplo.com" />
            </div>
          </div>
          <div class="mb-3">
            <label class="cm-label">DIRECCIÓN</label>
            <input v-model="form.direccion" type="text" class="form-control" placeholder="Dirección opcional" />
          </div>

          <div v-if="error" class="alert alert-danger py-2 fs-13">{{ error }}</div>
          <div v-if="yaExistia" class="alert alert-warning py-2 fs-13">⚠ Ya existe un cliente con ese documento. Se cargó el existente.</div>
        </div>

        <div class="cm-footer">
          <button class="btn btn-outline-secondary btn-sm" @click="$emit('cerrar')">Cancelar</button>
          <button class="btn btn-sm btn-purple" :disabled="guardando" @click="guardar">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            {{ guardando ? 'Guardando...' : 'Guardar cliente' }}
          </button>
        </div>

      </div>
    </div>
  </Teleport>
</template>

<script>
import api from '../../../services/api';

export default {
  name: 'ClienteModal',
  emits: ['cerrar', 'cliente-creado'],
  data() {
    return {
      form: { tipoper: 'N', tipodocid: 1, nrodoc: '', nombre: '', ape_pat: '', ape_mat: '', telefono: '', email: '', direccion: '' },
      guardando: false, error: null, yaExistia: false,
    };
  },
  methods: {
    async guardar() {
      this.error = null; this.yaExistia = false;
      if (!this.form.nrodoc.trim()) { this.error = 'El número de documento es requerido'; return; }
      if (!this.form.nombre.trim()) { this.error = 'El nombre es requerido'; return; }
      this.guardando = true;
      try {
        const res = await api.post('/clientes', this.form);
        const cli = res.data.data;
        this.yaExistia = cli.yaExistia;
        const nombreCompleto = [cli.nombre, cli.ape_pat].filter(x => x && x.trim()).join(' ').trim();
        this.$emit('cliente-creado', { idpersona: cli.idpersona, nombre: nombreCompleto, nrodoc: cli.nrodoc });
        if (!cli.yaExistia) this.$emit('cerrar');
      } catch (e) {
        this.error = e.response?.data?.error || 'Error al guardar cliente';
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.cliente-overlay { position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center; }
.cliente-modal { background:white;border-radius:12px;width:460px;max-width:95vw;max-height:90vh;display:flex;flex-direction:column;overflow:hidden; }
.cm-header { display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid #e5e7eb;background:#f8f7ff; }
.cm-close { background:none;border:none;font-size:18px;cursor:pointer;color:#6b7280;line-height:1; }
.cm-body { padding:20px;overflow-y:auto;flex:1; }
.cm-footer { display:flex;justify-content:flex-end;gap:10px;padding:14px 20px;border-top:1px solid #e5e7eb; }
.cm-label { display:block;font-size:11px;font-weight:700;letter-spacing:.8px;color:#7c3aed;margin-bottom:4px; }
.btn-purple { background:#7c3aed;color:white;border:none; }
.btn-purple:hover:not(:disabled) { background:#6d28d9; }
</style>
